import React from 'react'
import styles from './CurrentTicket.module.css'

function IncomingMessage ({message}) {
  return (
    <div className={styles.ticketItemWrapper}>
      <div className={styles.ticketItem}>
        <div className={styles.ticketItemTitle}>Служба поддержки</div>
        <div className={styles.ticketItemContent}>{message}</div>
      </div>
    </div>
  )
}

export default IncomingMessage
